<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">納入指示</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_DIL_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn @click="back" v-if="false">{{ $t('app.buttons.back') }}</v-btn>
        <v-btn
          :disabled="hasSent || selected.length === 0"
          @click="setWarehouse()"
          v-permit.SHARP_DIL_WAREHOUSE_SAVE
          >納入場所一括登録</v-btn
        >
        <v-btn
          :disabled="selected.length != 1 || hasFcl || !isMotherDo || hasSent"
          @click="split"
          v-permit.SHARP_DIL_SPLIT
          >D/O分け</v-btn
        >
        <v-btn
          :disabled="selected.length != 1 || hasFcl || isMotherDo"
          @click="combine"
          v-permit.SHARP_DIL_MERGE
          >D/O合併</v-btn
        >
        <v-btn
          :disabled="selected.length != 1 || selected[0].type === 'BOOKINGDO'"
          @click="toSetPattern"
          v-permit.SHARP_DIL_WH_SETTING
          >納入場所指定</v-btn
        >
        <v-btn
          :disabled="selected.length !== 1 || !canUpdateInfo || !hasFcl"
          @click="changeInfo"
          v-permit.SHARP_DIL_CHANGE
          >納入指示変更</v-btn
        >
        <v-btn :disabled="selected.length !== 1" @click="replace()"
          >仮予約置換</v-btn
        >
        <v-btn
          v-permit.SHARP_DIL_BOOKING_REMOVE
          :disabled="!canCancelBookingDo"
          @click="cancelBookingSa()"
          >仮予約取消</v-btn
        >
        <v-btn
          v-permit.RESERVE_WAREHOUSE_JUMP_BACK
          :disabled="selected.length != 1 || !hasFcl || hasSent"
          @click="needReserve()"
          >倉庫別予約一覧へ
        </v-btn>
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="D/O NO"
                v-model="query.doNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="B/L NO"
                v-model="query.blNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="納入指示者"
                url="employees/kv"
                v-model="query.operateDirectorId"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-select
                :items="[
                  '指示Mail送信済',
                  '納入指示済',
                  '事前指示メール送信済',
                  '事前納入指示済',
                ]"
                clearable
                label="納入指示Status"
                v-model="query.showStatus"
              ></v-select>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="納入場所"
                url="warehouses/kv"
                v-model="query.finallyWarehouseId"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <fixed-column-wrap :data="results">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="results"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            class="inline-edit"
            item-key="id"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td class="fixedTd">
                {{ props.item.buCode }} : {{ props.item.buName }}
              </td>
              <td class="fixedTd">
                <div v-show="props.item.type === 'BOOKINGDO'">約</div>
                {{ props.item.doNo }}
              </td>
              <td class="fixedTd">
                {{ props.item.branchCode }}
              </td>
              <td class="fixedTd">
                {{ props.item.blNo }}
              </td>
              <td class="fixedTd">
                {{ props.item.status }}
              </td>
              <td>{{ props.item.partnerName }}</td>
              <td>{{ props.item.forwarderName }}</td>
              <td v-if="!props.item.hasBookingSa">
                {{ props.item.containerNos }}
              </td>
              <td style="color: red" v-if="props.item.hasBookingSa">
                {{ props.item.containerNos }}
              </td>
              <td>{{ props.item.containerTypes }}</td>
              <td>{{ props.item.primarySkuCode }}</td>
              <td>{{ props.item.etd }}</td>
              <td>{{ props.item.eta }}</td>
              <td>{{ props.item.dischargePortName }}</td>
              <td>{{ props.item.transportModeCode }}</td>
              <td>{{ props.item.scWarehouseNames }}</td>
              <td>
                {{ props.item.deliveryPatternCode
                }}{{ props.item.deliveryPatternName }}
              </td>
              <td>{{ props.item.finallyWarehouseName }}</td>
              <td>{{ props.item.forecastDeliveryDate }}</td>
              <td class="justify-center">
                <v-btn
                  style="max-height: 24px"
                  @click="showBlDetail(props.item)"
                  >B/L 詳細</v-btn
                >
              </td>
              <td>{{ props.item.remark }}</td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <b-l-detail ref="blDetail" />
    <edit-location-dialog
      @submit="setFinallyWarehouseId"
      @refresh="clearPreSelected"
      ref="editLocationDialog"
    />
    <count-dialog @submit="changeCount" ref="count"></count-dialog>
    <edit-info
      :deliveryOrder="selected[0]"
      @refresh="load"
      ref="editInfo"
    ></edit-info>
  </v-container>
</template>

<script>
import BLDetail from './BLDetail'
import EditLocationDialog from './EditLocationDialog'
import CountDialog from './CountDialog'
import EditInfo from './EditInfoAfterSend'
export default {
  components: {
    BLDetail,
    EditLocationDialog,
    CountDialog,
    EditInfo,
  },
  data: () => ({
    loading: false,
    results: [],
    selected: [],
    preSelected: [],
    query: {
      moduleCode: 'F600',
      showStatus: null,
    },
    count: 0,
    headers: [
      {
        text: '事業本部',
        value: 'buName',
        sortable: false,
        width: '100',
        class: 'fixed',
      },
      {
        text: 'D/O NO',
        value: 'doNo',
        sortable: false,
        width: '100',
        class: 'fixed',
      },
      {
        text: '枝番',
        value: 'branchCode',
        sortable: false,
        width: '100',
        class: 'fixed',
      },
      {
        text: 'B/L NO',
        value: 'blNo',
        sortable: false,
        width: '100',
        class: 'fixed',
      },
      {
        text: '送信状態',
        value: 'status',
        sortable: false,
        width: '100',
        class: 'fixed',
      },
      {
        text: '海外取引先',
        value: 'partnerName',
        sortable: false,
      },
      {
        text: '船社・航空会社',
        value: 'forwarder',
        sortable: false,
      },
      {
        text: 'コンテナNo',
        value: 'containerNos',
        sortable: false,
      },
      {
        text: 'コンテナサイズ',
        value: 'containerType',
        sortable: false,
      },
      {
        text: '代表品番',
        value: 'sku',
        sortable: false,
      },
      {
        text: 'ETD',
        value: 'etd',
        sortable: false,
      },
      {
        text: 'ETA',
        value: 'eta',
        sortable: false,
      },
      {
        text: '陸揚港',
        value: 'dischargePortName',
        sortable: false,
      },
      {
        text: '運送形態',
        value: 'transportModeCode',
        sortable: false,
      },
      {
        text: 'SC 納入場所',
        value: 'warehouseName',
        sortable: false,
      },
      {
        text: '配送パターン',
        value: 'deliveryPatternCode',
        sortable: false,
      },
      {
        text: '予定納入場所',
        value: 'sjlWarehouseName',
        sortable: false,
      },
      {
        text: '納入予定日時間',
        value: 'forecastDeliveryDate',
        sortable: false,
      },
      {
        text: '詳細仕分',
        value: '',
        sortable: false,
      },
      {
        text: 'コメント',
        value: 'remark',
        sortable: false,
      },
    ],
    pagination: {
      page: 1,
    },
    errors: {
      WAREHOUSE_OR_DATE_DIFFERENT:
        '納入場所または納入予定日が違うため、事前仮合併ができません。',
      UP_TO_LIMIT: '受入上限本数を超えてしまうので、送信できません。',
      CAN_NOT_REPLACE: '置換えできません。',
    },
  }),
  methods: {
    isAllUnpaidWarehouseTransport(item) {
      return (
        item.isAllUnpaid &&
        item.specialId &&
        item.specialId.indexOf('WAREHOUSE_TRANSPORT') !== -1
      )
    },
    setWarehouse() {
      var totalBookingCount = 0
      Promise.all(
        this.selected.map((s) => {
          return this.$http
            .get(`/delivery-orders/${s.id}/booking-count`)
            .then((res) => {
              totalBookingCount += res.data
            })
        })
      ).then(() => {
        if (totalBookingCount > 0) {
          this.$confirm({
            content:
              '選択対象に事前納入指示済みデータがあります。事前納入指示済みデータに対して置換えバターンで置き換えください。事前納入指示を無視し引き続き一括登録しますか。',
            rejectAction: 'いいえ',
          })
            .then(() => {
              this.$refs.editLocationDialog.popup()
            })
            .catch(() => {})
        } else {
          this.$refs.editLocationDialog.popup()
        }
      })
    },
    replace() {
      var id = this.selected[0].id
      this.$http
        .get(`/delivery-orders/can-replace/${id}`)
        .then(() => {
          this.$router.push({
            path: '/replaced',
            query: {
              id: id,
            },
          })
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    cancelBookingSa() {
      this.$confirm({
        content: '該当事前仮取消して宜しいでしょうか？',
      }).then(() => {
        this.$http
          .put(`/delivery-orders/booking-sa/cancel/${this.selected[0].id}`)
          .then(() => {
            this.$message('', '事前仮取消が完了しました。')
            this.load()
          })
          .catch(() => {
            this.$message('', '事前仮取消が失敗しました。')
          })
      })
    },
    showError(res) {
      if (this.errors[res.response.data.message]) {
        this.$message(
          this.$t('app.messages.errors.title'),
          this.errors[res.response.data.message]
        )
      } else {
        this.$message(this.$t('app.messages.errors.title'), 'System Error.')
      }
    },
    changeInfo() {
      this.$refs.editInfo.popup(this.selected[0].id)
    },
    showBlDetail(item) {
      this.$refs.blDetail.popup(item.id).then((e) => {
        this.$http
          .put(`/delivery-orders/${item.id}/set-finally-warehouse`, {
            id: e.id,
            finallyWarehouseId: e.finallyWarehouseId,
            forecastDeliveryDate: e.forecastDeliveryDate,
            remark: e.remark,
          })
          .then(() => {
            this.load()
            this.$message('', '場所時間保存に成功する')
          })
      })
    },
    send() {
      var errorMsg = []
      var data = this.selected
      var arr = []
      var i = 0
      this.dealInstructionSend(data, i, errorMsg)
    },
    dealInstructionSend(data, i, errorMsg) {
      this.$http
        .put(`/delivery-orders/${data[i].id}/send-email-date`)
        .then(() => {
          this.doInstructionSend(i, data, errorMsg)
        })
        .catch(() => {
          errorMsg.push(data[i])
          this.doInstructionSend(i, data, errorMsg)
        })
    },

    doInstructionSend(i, data, errorMsg) {
      if (i < data.length - 1) {
        this.dealInstructionSend(data, i + 1, errorMsg)
      } else {
        if (errorMsg.length === 0) {
          this.selected = []
          this.load()
          this.$message('', '納入指示済')
        }
        if (errorMsg.length > 0) {
          console.log(errorMsg)
          var msg = errorMsg.map((e) => e.blNo + '-' + e.branchCode).join(',')
          this.selected = []
          this.load()
          this.$message('', msg + ':' + 'ERROR')
        }
      }
    },

    primarySku(item) {
      var codes = item.packages.filter((p) => p.skuCode && p.skuCode != '')
      if (codes.length > 0) {
        return codes[0].skuCode
      }
      return ''
    },
    scWarehouses(item) {
      return item.packages
        .map((p) => p.scWarehouseName)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    combine() {
      var doShipmentId = this.selected[0].doShipmentId
      return this.$http
        .put(`delivery-orders/combine/${this.selected[0].id}`)
        .then(() => {
          this.selected = []
          this.load()
        })
        .then(() => {
          this.load()
          this.$message('合わせる', '合併に成功する')
        })
    },
    toSetPattern() {
      let order = this.selected[0]
      this.$http
        .get(`/delivery-orders/${order.id}/booking-count`)
        .then((res) => {
          if (res.data > 0) {
            this.$confirm({
              content: '事前納入指示があります。置き換えますか。',
              rejectAction: 'いいえ',
            })
              .then(() => {
                this.replace()
              })
              .catch(() => {
                this.$router.push({
                  path: '/B0602',
                  query: {
                    id: order.id,
                  },
                })
              })
          } else {
            this.$router.push({
              path: '/B0602',
              query: {
                id: order.id,
              },
            })
          }
        })
    },
    changeCount(count) {
      this.count = count
    },
    search() {
      this.$storeParams()
      this.preSelected = []
      this.pagination.page = 0
      this.load()
    },
    load() {
      this.query.moduleCode = 'F600'
      this.autoload = true
      this.loading = true
      this.results = []
      return this.$http
        .get('/delivery-orders', {
          params: {
            ...this.query,
            ...this.$pageable(),
          },
        })
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
          if (this.preSelected.length > 0) {
            this.selected = this.preSelected.map((p) => ({
              ...p,
              id: p.shipmentId,
            }))
          }
        })
    },
    clearPreSelected() {
      this.preSelected = []
      // this.load()
    },
    back() {
      this.$router.go(-1)
    },
    validInOneYear(e) {
      for (var i = 0; i < this.selected.length; i++) {
        var eta = this.selected[i].eta
        var forecastDeliveryDate = e.forecastDeliveryDate
        if (this.$daysBetween(eta, forecastDeliveryDate) > 30) {
          return false
        } else {
          return true
        }
      }
    },
    setFinallyWarehouseId(e) {
      if (!this.validInOneYear(e)) {
        this.$confirm({
          content:
            'ＥＴＡから３０日以上経過していますので、問題がないかご確認ください',
          action: 'そのまま保存',
          rejectAction: 'キャンセル',
        })
          .then(() => {
            this.doBatchSetWarehouse(e)
          })
          .catch(() => {})
      } else {
        this.doBatchSetWarehouse(e)
      }
    },
    doBatchSetWarehouse(e) {
      Promise.all(
        this.selected.map((item) => {
          return this.$http.put(
            `/delivery-orders/${item.id}/set-finally-warehouse`,
            {
              id: e.id,
              finallyWarehouseId: e.finallyWarehouseId,
              forecastDeliveryDate: e.forecastDeliveryDate,
              forecastDeliveryTime: e.forecastDeliveryTime,
              remark: e.remark,
            }
          )
        })
      ).then(() => {
        this.send()
      })
    },
    split() {
      this.$router.push({
        name: 'splitB0600',
        query: {
          id: this.selected[0].id,
        },
      })
    },
    containerNos(item) {
      return item.packages
        .map((p) => p.containerNo)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    containerTypes(item) {
      return item.packages
        .map((p) => p.containerTypeCode)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    skuCodes(item) {
      return item.packages
        .map((p) => p.skuCode)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    needReserve() {
      Promise.all(
        this.selected.map((s) => {
          return this.$http.put(
            `/warehouse-container-settings/change-need-reserve/${s.id}`
          )
        })
      )
        .then(() => {
          this.$message('', '倉庫別予約一覧へ遷移しました。')
          this.$router.push({
            name: 'B2300',
            params: {
              blNo: this.selected[0].blNo,
              selected: this.selected,
            },
          })
        })
        .catch(() => {
          this.$message('', '倉庫別予約一覧へ遷移できません。')
        })
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  mounted() {
    this.$loadParams()
    var blNo = this.$route.query.blNo
    if (blNo) {
      this.query.blNo = blNo
    }
    var params = this.$route.params
    if (params.blNo) {
      this.query.blNo = params.blNo
      this.load()
      this.preSelected = params.selected
    }
  },
  computed: {
    hasAllUnpaidWarehouseTransport() {
      return (
        this.selected.filter((item) => this.isAllUnpaidWarehouseTransport(item))
          .length > 0
      )
    },
    canCancelBookingDo() {
      return (
        this.selected.length === 1 &&
        this.selected.filter((s) => s.hasBookingSa).length === 1 &&
        this.selected.filter((s) => s.status === '事前受入確認済').length === 0
      )
    },
    canMergeSa() {
      return (
        this.selected.filter((s) => s.type === 'DO').length === 1 &&
        this.selected.filter((s) => s.type === 'BOOKINGDO').length === 1
      )
    },
    canUpdateInfo() {
      return (
        this.selected.map((s) => s.status).filter((s) => s === '納入指示済')
          .length === this.selected.length
      )
    },
    hasFcl() {
      return (
        this.selected.filter((s) => s.stackTypeId == 'STACK_TYPE-FCL').length >
        0
      )
    },
    isMotherDo() {
      return this.selected[0].branchCode == '999' ? true : false
    },
    hasSent() {
      return (
        this.selected
          .map((s) => s.status)
          .filter(
            (s) =>
              s !== '指示Mail送信済' &&
              s !== 'SJL送信済' &&
              s !== 'SA一時保存-SJL' &&
              s !== '事前納入指示Mail送信済'
          ).length > 0
      )
    },
  },
}
</script>

<style>
table.v-table tbody td .v-text-field .v-messages {
  display: none !important;
}
</style>
